module.exports = __webpack_public_path__ + "img/coupon_1.c3235665.jpg";